<!--
File Name          : air-racer.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="lesson-component-container">
  <div
    class="scalar-datum"
    *ngIf="scalars.includes(AirRacerFields.AVERAGE_VELOCITY)"
  >
    <div class="datum-title">Avg Velocity</div>
    <div class="datum-value">
      {{ localVariableSigFigsFormatter(results?.avg_velocity) }} m/s
    </div>
  </div>
  <div
    class="scalar-datum"
    *ngIf="scalars.includes(AirRacerFields.MAX_VELOCITY)"
  >
    <div class="datum-title">Max Velocity</div>
    <div class="datum-value">
      {{ localVariableSigFigsFormatter(results?.max_velocity) }} m/s
    </div>
  </div>
  <div class="scalar-datum" *ngIf="scalars.includes(AirRacerFields.RACE_TIME)">
    <div class="datum-title">Race Time</div>
    <div class="datum-value">
      {{
        results?.isDNF
          ? "DNF"
          : localVariableSigFigsFormatter(results?.race_time) + " S"
      }}
    </div>
  </div>
  <div
    class="scalar-datum"
    *ngIf="scalars.includes(AirRacerFields.LAUNCH_ACCEL)"
  >
    <div class="datum-title">Launch Acceleration</div>
    <div class="datum-value">
      {{
        localVariableSigFigsFormatter(
          results?.max_acceleration != undefined
            ? results!.max_acceleration / 9.8
            : undefined
        )
      }}
      G
    </div>
  </div>
  <div
    class="scalar-datum"
    *ngIf="scalars.includes(AirRacerFields.LATERAL_DRIFT)"
  >
    <div class="datum-title">Lateral Drift</div>
    <div class="datum-value">
      {{ localVariableSigFigsFormatter(results?.horizontal_drift) }} Rads
    </div>
  </div>
  <div
    class="scalar-datum"
    *ngIf="scalars.includes(AirRacerFields.VERTICAL_DRIFT)"
  >
    <div class="datum-title">Vertical Drift</div>
    <div class="datum-value">
      {{ localVariableSigFigsFormatter(results?.vertical_drift) }} Rads
    </div>
  </div>
  <div class="scalar-datum" *ngIf="scalars.includes(AirRacerFields.IMPACT_G)">
    <div class="datum-title">Impact Gs</div>
    <div class="datum-value">
      {{ localVariableSigFigsFormatter(results?.impact_G) }} G
    </div>
  </div>

  @if (screenservice.isMobile) {
    <div class="chart-container mobile-chart-options">
      <div style="text-align: center; margin-bottom: 8px">Select to Graph</div>
      <div class="chart-controls">
        <dx-button
          *ngFor="let series of availableDataSeries"
          [text]="series.text"
          icon="datatrending"
          [disabled]="false"
          stylingMode="contained"
          type="default"
          (onClick)="openMobileChart(series.valueField)"
        ></dx-button>
      </div>
    </div>
  } @else {
    <div class="chart-container">
      <div class="chart-controls">
        <div>Select to Graph</div>
        <dx-button-group
          [items]="availableDataSeries"
          [(selectedItemKeys)]="selectedDataSeries"
          selectionMode="single"
          stylingMode="outlined"
          keyExpr="valueField"
        ></dx-button-group>
      </div>
      <div class="chart-with-labels" style="height: calc(100% - 36px)">
      <dx-chart
        [dataSource]="results?.data ?? []"
        style="height: 100%"
        (onDrawn)="onChartDrawn($event)"
        (onZoomEnd)="onChartZoomEnd($event)"
      >
        <dxo-zoom-and-pan
          argumentAxis="both"
          valueAxis="none"
          [allowMouseWheel]="true"
          [allowTouchGestures]="true"
        >
          <!-- or "zoom" | "pan" | "none" -->
        </dxo-zoom-and-pan>
        <dxo-tooltip
          [enabled]="true"
          [customizeTooltip]="customizeTooltip"
        ></dxo-tooltip>
        <dxo-size [height]="360"> </dxo-size>
        <!-- <dxo-title text="Acceleration Magnitude" horizontalAlignment="center"></dxo-title> -->
        <dxo-legend [visible]="false"></dxo-legend>
        <dxo-common-series-settings
          #seriesSettings
          argumentField="timestamp"
          type="spline"
        >
          <dxo-point [visible]="false"></dxo-point>
        </dxo-common-series-settings>
        <dxo-common-axis-settings [valueMarginsEnabled]="true">
          <dxo-label>
            <dxo-font size="18"></dxo-font>
          </dxo-label>
        </dxo-common-axis-settings>
        <dxi-series
          *ngIf="isSeriesSelected('acceleration')"
          color="#424242"
          valueField="accel"
          axis="accel_axis"
        ></dxi-series>
        <dxi-series
          *ngIf="isSeriesSelected('velocity')"
          color="#424242"
          valueField="vel"
          axis="vel_axis"
        ></dxi-series>
        <dxi-series
          *ngIf="isSeriesSelected('position')"
          color="#424242"
          valueField="pos"
          axis="pos_axis"
        ></dxi-series>
        <dxo-argument-axis [valueMarginsEnabled]="false">
          <dxi-strip
            [startValue]="getLaunchStripStart()"
            [endValue]="results?.timeline?.launch_end"
            color="#66bb6a"
          ></dxi-strip>
          <dxi-strip
            [startValue]="results?.timeline?.launch_end"
            [endValue]="results?.timeline?.impact_start"
            color="#ffcc80"
          ></dxi-strip>
          <dxi-strip
            [startValue]="results?.timeline?.impact_start"
            [endValue]="results?.timeline?.impact_end"
            color="#ef9a9a"
          ></dxi-strip>
          <dxo-title text="Time (s)">
            <dxo-font size="24" weight="bold"></dxo-font>
          </dxo-title>
        </dxo-argument-axis>
        <dxi-value-axis
          *ngIf="isSeriesSelected('acceleration')"
          type="continuous"
          name="accel_axis"
          [minValueMargin]="0.1"
          [maxValueMargin]="0.1"
        >
          <dxo-title text="Acceleration (G)">
            <dxo-font size="24" weight="bold"></dxo-font>
          </dxo-title>
          <dxo-chart-label
            [customizeText]="roundDownChartLabel"
          ></dxo-chart-label>
        </dxi-value-axis>
        <dxi-value-axis
          *ngIf="isSeriesSelected('velocity')"
          type="continuous"
          name="vel_axis"
          [valueMarginsEnabled]="true"
          [minValueMargin]="0.1"
          [maxValueMargin]="0.1"
        >
          <dxo-title text="Velocity (m/s)">
            <dxo-font size="24" weight="bold"></dxo-font>
          </dxo-title>
        </dxi-value-axis>
        <dxi-value-axis
          *ngIf="isSeriesSelected('position')"
          type="continuous"
          name="pos_axis"
          [valueMarginsEnabled]="true"
          [minValueMargin]="0.1"
          [maxValueMargin]="0.1"
        >
          <dxo-title text="Distance (m)">
            <dxo-font size="24" weight="bold"></dxo-font>
          </dxo-title>
        </dxi-value-axis>
      </dx-chart>
        <div class="zone-label-overlay">
          <span class="zone-label" data-zone="launch" style="color: #1b5e20">Launch</span>
          <span class="zone-label" data-zone="race" style="color: #e65100">Race</span>
          <span class="zone-label" data-zone="impact" style="color: #b71c1c">Impact</span>
        </div>
      </div>
    </div>
  }
</div>

<dx-popup
  [visible]="mobileChartSelection !== null"
  [showTitle]="true"
  [title]="getChartPopupTitle()"
  width="100%"
  height="100%"
  maxWidth="100%"
  maxHeight="100%"
  [dragEnabled]="true"
  [showCloseButton]="true"
  [hideOnOutsideClick]="false"
  [dragEnabled]="false"
  (onHiding)="mobileChartSelection = null"
  (onShowing)="onPopupShowing()"
  (onShown)="onPopupShown()"
>
  @if (screenservice.isLandscape) {
    <div
      style="height: 100%; width: 100%; display: flex; flex-direction: column"
      [attr.data-chart-key]="chartKey"
    >
      <div class="chart-with-labels" style="flex: 1 1 auto; min-height: 0; width: 100%">
      <dx-chart
        [dataSource]="results?.data ?? []"
        style="height: 100%; width: 100%"
        (onDrawn)="onChartDrawn($event)"
        (onZoomEnd)="onChartZoomEnd($event)"
      >
        <dxo-zoom-and-pan
          argumentAxis="both"
          valueAxis="none"
          [allowMouseWheel]="true"
          [allowTouchGestures]="true"
        >
          <!-- or "zoom" | "pan" | "none" -->
        </dxo-zoom-and-pan>
        <dxo-tooltip
          [enabled]="true"
          [customizeTooltip]="customizeTooltip"
          [zIndex]="10000"
        ></dxo-tooltip>
        <!-- <dxo-title text="Acceleration Magnitude" horizontalAlignment="center"></dxo-title> -->
        <dxo-legend [visible]="false"></dxo-legend>
        <dxo-common-series-settings
          #seriesSettings
          argumentField="timestamp"
          type="spline"
        >
          <dxo-point [visible]="false"></dxo-point>
        </dxo-common-series-settings>
        <dxo-common-axis-settings [valueMarginsEnabled]="true">
          <dxo-label>
            <!-- <dxo-font size="18"></dxo-font> -->
          </dxo-label>
        </dxo-common-axis-settings>
        <dxi-series
          *ngIf="isSeriesSelected('acceleration')"
          color="#424242"
          valueField="accel"
          axis="accel_axis"
        ></dxi-series>
        <dxi-series
          *ngIf="isSeriesSelected('velocity')"
          color="#424242"
          valueField="vel"
          axis="vel_axis"
        ></dxi-series>
        <dxi-series
          *ngIf="isSeriesSelected('position')"
          color="#424242"
          valueField="pos"
          axis="pos_axis"
        ></dxi-series>
        <dxo-argument-axis [valueMarginsEnabled]="false">
          <dxi-strip
            [startValue]="getLaunchStripStart()"
            [endValue]="results?.timeline?.launch_end"
            color="#66bb6a"
          ></dxi-strip>
          <dxi-strip
            [startValue]="results?.timeline?.launch_end"
            [endValue]="results?.timeline?.impact_start"
            color="#ffcc80"
          ></dxi-strip>
          <dxi-strip
            [startValue]="results?.timeline?.impact_start"
            [endValue]="results?.timeline?.impact_end"
            color="#ef9a9a"
          ></dxi-strip>
          <dxo-title text="Time (s)">
            <!-- <dxo-font size="24" weight="bold"></dxo-font> -->
          </dxo-title>
        </dxo-argument-axis>
        <dxi-value-axis
          *ngIf="isSeriesSelected('acceleration')"
          type="continuous"
          name="accel_axis"
          [minValueMargin]="0.1"
          [maxValueMargin]="0.1"
        >
          <dxo-title text="Acceleration (G)">
            <dxo-font size="16" weight="bold"></dxo-font>
          </dxo-title>
          <dxo-chart-label
            [customizeText]="roundDownChartLabel"
          ></dxo-chart-label>
        </dxi-value-axis>
        <dxi-value-axis
          *ngIf="isSeriesSelected('velocity')"
          type="continuous"
          name="vel_axis"
          [minValueMargin]="0.1"
          [maxValueMargin]="0.1"
        >
          <dxo-title text="Velocity (m/s)">
            <dxo-font size="16" weight="bold"></dxo-font>
          </dxo-title>
        </dxi-value-axis>
        <dxi-value-axis
          *ngIf="isSeriesSelected('position')"
          type="continuous"
          name="pos_axis"
          [minValueMargin]="0.1"
          [maxValueMargin]="0.1"
        >
          <dxo-title text="Distance (m)">
            <dxo-font size="16" weight="bold"></dxo-font>
          </dxo-title>
        </dxi-value-axis>
      </dx-chart>
        <div class="zone-label-overlay">
          <span class="zone-label" data-zone="launch" style="color: #1b5e20">Launch</span>
          <span class="zone-label" data-zone="race" style="color: #e65100">Race</span>
          <span class="zone-label" data-zone="impact" style="color: #b71c1c">Impact</span>
        </div>
      </div>
    </div>
  } @else {
    <div
      style="
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
        height: 100%;
        text-align: center;
      "
    >
      <span>Device must be in Landscape to view graphs.</span>
    </div>
  }
</dx-popup>
